<script>
  import appConfig from "@/app.config";
  import axios from 'axios';
  
  // 초기세팅
  function initialState() {
    return {
      token: "",
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      mailList: [],
      mailFields: [
        {key: 'name', label: '발신자', thClass: 'col-3 text-center font-size-11', tdClass: ' text-center'},
        {key: 'subject', label: '제목', thClass: 'col-6 text-left font-size-11', tdClass: ' text-left'},
        {key: 'date', label: '수신일시', thClass: 'col-2 text-left font-size-11', tdClass: ' text-left'},
        {key: 'delete', label: '삭제', thClass: 'col-1 text-center font-size-11', tdClass: ' text-center'},
      ],
      selectedMail: null,
      showMailModal: false,
      // Pagination
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
    };
  }
  
  export default {
    components: {
    },
    data() {
      return initialState();
    },
    props: {
      selectedMenu: {
        type: String,
      },
    },
    computed: {
    },
    watch: {
      currentPage(newPage) {
        // 페이지가 변경될 때마다 메일 목록을 다시 불러옴
        if (newPage > 0) {
          this.getMailList()
        }
      }
    },
    mounted() {
    },
    created() {
      this.first()
    },
    methods: {
      first() {
        let getLocalStorage = JSON.parse(localStorage.getItem('user'))
        if (getLocalStorage) {
          this.login.idx = getLocalStorage.idx
          this.login.nick = getLocalStorage.nick
          this.login.level = getLocalStorage.level
          this.token = getLocalStorage.token


          if (this.login.level == 99) {
            this.getMailList()
          } else if (this.login.level == 98) {
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '최고관리 권한이 없습니다.' })
            this.$router.push('/admin/');
          } else {
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
            this.$router.push('/');
          }
        } else {
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '관리자 권한이 없습니다.' })
          this.$router.push('/');
        }
      },
      getMailList() {
        try {
          this.loadingBar(true)
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/mail/read_email_inbox',
            headers: {
              'access-token': this.token
            },
            data: {
              "mb_idx": this.login.idx,
              "page": this.currentPage,
              "limit": this.perPage,
              "search": null
            },
          })
          .then((res) => {
            if (res.data.type == 'success') {
              this.mailList = res.data.mailList || []
              // API 응답에 totalRows가 있다면 사용, 없으면 mailList 길이로 설정
              this.totalRows = res.data.totalRows || res.data.total || this.mailList.length
            }
          })
          .catch((error) => {
            console.log(error)
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
          })
        } catch (error) {
          console.log(error)
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        } finally {
          this.loadingBar(false)
        }
      },
      // 페이지 변경 핸들러 (watch에서 처리하므로 제거 가능하지만, 명시적으로 유지)
      onPageChange(button, page) {
        // button은 이벤트 객체, page는 페이지 번호
        this.currentPage = page
        // watch에서 자동으로 getMailList()가 호출됨
      },
      // 단일 삭제
      deleteMail(id) {
        this.deleteMails([id])
      },

      // 여러 개 삭제 (체크박스로 선택한 경우)
      deleteMails(ids) {
        // 정말 삭제하실겁니까?
        const result = window.confirm("정말 삭제하시겠습니까?");
        if (result) {
          try {
            this.loadingBar(true)
            axios({
              method: 'POST',
              url: appConfig.fastapi + '/mail/delete_email',
              headers: {
                'access-token': this.token
              },
              data: {
                "mb_idx": this.login.idx,
                "mail_ids": ids  // 배열 그대로 전송
              },
            })
            .then((res) => {
              if (res.data.type == 'success') {
                this.$notify({ 
                  type: 'success', 
                  duration: 2000, 
                  title: '성공', 
                  text: res.data.detail || '삭제되었습니다.' 
                })
                // 삭제 후 현재 페이지의 아이템이 없으면 이전 페이지로 이동
                if (this.mailList.length === 1 && this.currentPage > 1) {
                  this.currentPage--
                }
                // 메일함 다시읽기
                this.getMailList()
                // 모달 켜져있으면 닫기
                this.closeMailModal()
              } else {
                this.$notify({ type: 'error', duration: 2000, title: '실패', text: res.data.detail })
              }
            })
            .catch((error) => {
              console.log(error)
              this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
            })
          } catch (error) {
            console.log(error)
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
          } finally {
            this.loadingBar(false)
          }
        }
      },
      // 기다려주세요 loading 처리
      loadingBar(val) {
        this.$nextTick(() => {
          const preloader = document.getElementById("preloader");
          const status = document.getElementById("status");
          
          if (preloader && status) {
            if (val === true) {
              preloader.style.display = "block";
              status.style.display = "block";
            } else {
              preloader.style.display = "none";
              status.style.display = "none";
            }
          }
        });
      },
      // 메일 상세 보기
      showMailDetail(mail) {
        this.selectedMail = mail;
        this.showMailModal = true;
        this.$bvModal.show('mailDetailModal');
        // 읽음 전이면 읽음 표시해주자
        if (!mail.read) {
          this.updateMailRead(mail.id)
        }
      },
      // 메일 읽음 표시
      updateMailRead(id) {
        try {
          this.loadingBar(true)
          axios({
            method: 'POST',
            url: appConfig.fastapi + '/mail/read_email_mark_as_read',
            headers: {
              'access-token': this.token
            },
            data: {
              "mb_idx": this.login.idx,
              "mail_id": id
            },
          })
          .then((res) => {
            if (res.data.type !== 'success') {
              this.$notify({ type: 'error', duration: 2000, title: '실패', text: res.data.detail })
            }
          })
          .catch((error) => {
            console.log(error)
            this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
          })
        } catch (error) {
          console.log(error)
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '요청 중 에러 발생 관리자에게 문의'+error })
        } finally {
          this.loadingBar(false)
        }
      },
      // 모달 닫기
      closeMailModal() {
        this.$bvModal.hide('mailDetailModal');
        this.selectedMail = null;
      },
      // 메일함 다시읽기
      reloadMailList() {
        this.currentPage = 1
        this.getMailList()
        this.$notify({ type: 'success', duration: 2000, title: '성공', text: '메일함 다시읽기 완료' })
      },
      // filename이 Screenshot (1).png 라면 11_Screenshot _1_.png로 변경해서 저장되거든?
      // filename에 공백은 그대로 유지하고 괄호만 _ 로 변경
      getAttachmentFilename(filename) {
        // URL 디코딩 먼저 수행 (decodeURIComponent는 %20을 공백으로 변환)
        let decoded = decodeURIComponent(filename)
        // 괄호만 언더스코어로 변경 (공백은 그대로 유지)
        return decoded.replace(/\(/g, '_').replace(/\)/g, '_')
      },
      getAttachmentUrl(filename) {
        return 'https://img.himne.org/email/' + this.selectedMail.id + '_' + this.getAttachmentFilename(filename)
      },
      // 첨부파일 다운로드
      async downloadAttachment(attachment) {
        try {
          this.loadingBar(true)
          const response = await fetch(appConfig.fastapi + `/mail/download_attachment/${attachment.id}`, {
            headers: {
              'access-token': this.token
            }
          })
          
          if (!response.ok) {
            throw new Error('다운로드 실패')
          }
          
          const blob = await response.blob()
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = attachment.filename
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
          
          this.$notify({ type: 'success', duration: 2000, title: '성공', text: '다운로드가 시작되었습니다.' })
        } catch (error) {
          console.log(error)
          this.$notify({ type: 'error', duration: 2000, title: '실패', text: '다운로드 중 에러가 발생했습니다.' })
        } finally {
          this.loadingBar(false)
        }
      },
      // 첨부파일 용량 가져오기 (킬로바이트 단위로 보여주기 소숫점제거)
      getAttachmentSize(size) {
        return Math.round(size / 1024) + 'KB'
      }
    },
  }
  </script>
  
  <template>
    
    <div class="rounded shadow">
      
      <!-- 메일 상세 모달 -->
      <b-modal
        id="mailDetailModal"
        ref="mailDetailModal"
        title="메일 상세"
        size="xl"
        @hidden="closeMailModal"
        hide-footer
      >
        <div class="modal-header border-0">
          <div class="row">
            <div v-if="selectedMail" class="mail-detail font-size-12">
              <div class="">
                <div class="row mb-1">
                  <div class="col-xl-12 col-md-12 col-sm-12">발신자</div>
                  <div class="col-xl-12 col-md-12 col-sm-12 text-secondary font-weight-bold">
                    <span class="text-secondary">{{ selectedMail.from }}</span>
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="col-xl-12 col-md-12 col-sm-12">제목</div>
                  <div class="col-xl-12 col-md-12 col-sm-12 text-secondary  font-weight-bold">{{ selectedMail.subject }}</div>
                </div>
                <div class="row mb-1">
                  <div class="col-xl-12 col-md-12 col-sm-12">수신일시</div>
                  <div class="col-xl-12 col-md-12 col-sm-12 text-secondary font-weight-bold">{{ selectedMail.date }}</div>
                </div>
                <div v-if="selectedMail.has_attachment" class="row mb-1">
                  <div class="col-xl-12 col-md-12 col-sm-12">
                    첨부파일
                  </div>
                  <div class="col-9">
                    <i class="mdi mdi-paperclip"></i> {{ selectedMail.attachments.length }}개
                    <span v-for="attachment in selectedMail.attachments" :key="attachment.id" class="mr-3">
                      <a href="javascript:void(0)" @click="downloadAttachment(attachment)" style="cursor: pointer; text-decoration: underline;">{{ attachment.filename }} ({{ getAttachmentSize(attachment.file_size) }})</a>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body border">
          <div class="mb-3">
            <div v-if="selectedMail" class="" style="min-height: 200px; max-width: 100%;">
              <!-- html 형식으로 보여주기 -->
              <div v-html="selectedMail.body_html"></div>
            </div>
          </div>

          <hr class="my-0">

          <div class="mt-3">
            <div class="text-secondary">
              <span @click="deleteMail(selectedMail.id)" class="badge badge-danger font-size-10 cursor-pointer">
                <i class="mdi mdi-delete"></i> 삭제하기
              </span>
            </div>
          </div>
        </div>
        <template #modal-footer>
          <b-button variant="secondary" @click="closeMailModal">닫기</b-button>
        </template>
      </b-modal>

      <div class="p-4 border-bottom">
        <h5 class="text-md-left text-center">hi@himne.org (수신전용)</h5>
        <span class="text-secondary font-size-12">
          이 페이지는 최고관리자만 이용 가능합니다. 안쓰는 이메일은 <b class="text-primary">주기적으로 삭제해서 관리해주세요</b>
        </span>
        <hr class="my-2"></hr>
        <div>
          <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12 mb-4">
              <div class="mb-3">
                <button class="btn btn-sm btn-outline-primary" @click="reloadMailList">
                  <i class="mdi mdi-refresh"></i> 메일함 다시읽기
                </button>
              </div>
              <!-- Pagination -->
              <div class="mt-3 mb-3 d-flex justify-content-center">
                <ul class="pagination mb-0">
                  <b-pagination
                    v-if="totalRows > 0"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="mailListTable"
                    @page-click="onPageChange"
                    limit="6"
                  >
                    <template #first-text><span class="text-primary">처음</span></template>
                    <template #prev-text><span class="text-secondary">이전</span></template>
                    <template #next-text><span class="text-secondary">다음</span></template>
                    <template #last-text><span class="text-primary">마지막</span></template>
                    <template #page="{ page, active }">
                      <b v-if="active">{{ page }}</b>
                      <span v-else>{{ page }}</span>
                    </template>
                  </b-pagination>
                </ul>
              </div>
              <div class="table table-sm table-responsive font-size-14">
                <b-table 
                  id="mailListTable" 
                  ref="mailListTable" 
                  :fields="mailFields" 
                  :items="mailList" 
                  :hover="true"
                  table-class="text-center font-size-12">
                  <!-- 수신일시 -->
                  <template #cell(date)="row">
                    <div class="text-secondary">
                      {{ row.item.date }}
                    </div>
                  </template>
                  <!-- 발신자 -->
                  <template #cell(name)="row">
                    <div class="text-secondary" :title="row.item.from">
                      {{ row.item.name }}
                    </div>
                  </template>
                  <!-- 제목 -->
                  <template #cell(subject)="row">
                    <div class="text-secondary">
                      <span v-if="row.item.has_attachment">
                        [<i class="mdi mdi-paperclip"></i>첨부]
                      </span>
                      <span 
                        v-if="row.item.read" 
                        class="text-secondary cursor-pointer" 
                        @click="showMailDetail(row.item)"">
                        {{ row.item.subject }}
                      </span>
                      <span 
                        v-else 
                        class="text-blue font-weight-bold cursor-pointer" 
                        @click="showMailDetail(row.item)">
                         {{ row.item.subject }} 
                         <!-- 새 메일 아이콘 -->
                          <i class="mdi mdi-email-plus text-info font-size-12"></i>
                      </span>
                    </div>
                  </template>
                  <!-- 삭제 -->
                  <template #cell(delete)="row">
                    <div class="text-secondary">
                      <span @click="deleteMail(row.item.id)" class="badge badge-danger font-size-10 cursor-pointer">삭제</span>
                    </div>
                  </template>
                </b-table>
              </div>
              <!-- Pagination -->
              <div class="mt-3 d-flex justify-content-center">
                <ul class="pagination mb-0">
                  <b-pagination
                    v-if="totalRows > 0"
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    aria-controls="mailListTable"
                    @page-click="onPageChange"
                    limit="6"
                  >
                    <template #first-text><span class="text-primary">처음</span></template>
                    <template #prev-text><span class="text-secondary">이전</span></template>
                    <template #next-text><span class="text-secondary">다음</span></template>
                    <template #last-text><span class="text-primary">마지막</span></template>
                    <template #page="{ page, active }">
                      <b v-if="active">{{ page }}</b>
                      <span v-else>{{ page }}</span>
                    </template>
                  </b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </template>